module.exports = __webpack_public_path__ + "resource/img/image031.2051358b.png";